import { ProductItem } from '~/components/core/product/adapters/product-types';
import { EditParcelButton } from './header/edit-parcel-button';
import { P2GGrid } from '@parcel2go/core-ui';
import { DuplicateItem } from './header/duplicate-item';
import { DeleteItem } from './header/delete-item';

export const BasketSummaryHeaderSuffix = ({
  index,
  name,
  productItem,
  onEdit,
  onRemove,
  onDuplicate,
  setOpenSwitcher,
  isXs
}: {
  index: number;
  name: string;
  productItem: ProductItem;
  onEdit: (id: string, action: string) => void;
  onRemove: (id: string) => void;
  onDuplicate: (id: string) => void;
  setOpenSwitcher: (open: boolean) => void;
  isXs?: boolean;
}) => {
  const options = [
    'SwitchService',
    'Origin',
    'Parcels',
    productItem.service.isDropOffService ? 'DropLocations' : 'CollectionDate',
    productItem.service.isShopDelivery ? 'DestinationPickUpLocations' : undefined
  ].filter(Boolean) as string[];

  if (isXs) {
    return (
      <P2GGrid item xs={12}>
        <EditParcelButton
          options={options}
          index={index}
          name={name}
          onEdit={onEdit}
          onRemove={onRemove}
          onDuplicate={onDuplicate}
          setOpenSwitcher={setOpenSwitcher}
          fullWidth={isXs}
        />
      </P2GGrid>
    );
  }

  return (
    <>
      <P2GGrid item display="flex" justifyContent="flex-end">
        <DuplicateItem index={index} name={name} onDuplicate={onDuplicate} size="xs" />
      </P2GGrid>
      <P2GGrid item display="flex" justifyContent="flex-end">
        <DeleteItem index={index} name={name} onRemove={onRemove} size="xs" />
      </P2GGrid>
    </>
  );
};
